import React from 'react';
import LoginForm from './Login';
import { Layout } from './App';
import { useAuth } from './AuthContext';

const Loadfirsts = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Layout /> : <LoginForm />;
};
export default Loadfirsts;
